import { useState, useCallback, useEffect } from 'react';
import pointsWithinPolygon from '@turf/points-within-polygon';
import { featureCollection, point, polygon } from '@turf/helpers';
import { Position } from 'deck.gl';
import { IMarker } from '../../../../types/marker';

export function useInsituAvailability(
  selectedDatazone: any,
  inSituPoints: any[],
  activePoint?: IMarker,
  showInSituPoints?: boolean,
  datasetId?: string,
  enabled = false
) {
  const [isInsituAvailable, setIsInsituAvailable] = useState(false);
  const [disabledChart, setDisableChart] = useState(false);

  const isValidInsitu = useCallback(() => {
    if (showInSituPoints) {
      const tolerance = 0.000001;
      if (selectedDatazone) {
        const selectedPolygon = polygon([selectedDatazone.coordinates as Position[]]);
        const points = featureCollection(inSituPoints.map(({position}) => point(position)));
        const pointsInside = pointsWithinPolygon(points, selectedPolygon);

        setIsInsituAvailable(pointsInside.features.length > 0);
      } else {
        setIsInsituAvailable(false);
      }

      const findInSitu = inSituPoints.find((item) => {
        if (activePoint?.coordinates) {
          const itemX = item.position[0];
          const itemY = item.position[1];
          const activeX = activePoint.coordinates[0];
          const activeY = activePoint.coordinates[1];

          const isXCloseEnough = Math.abs(itemX - activeX) < tolerance;
          const isYCloseEnough = Math.abs(itemY - activeY) < tolerance;

          if (isXCloseEnough && isYCloseEnough) {
            return true;
          }
        }
        return false;
      });

      setDisableChart(Boolean(findInSitu));
    }
  }, [inSituPoints, activePoint?.coordinates, showInSituPoints, datasetId, selectedDatazone]);

  useEffect(() => {
    if(!enabled) return
    isValidInsitu();
  }, [activePoint?.coordinates, inSituPoints, showInSituPoints, datasetId, isValidInsitu, enabled]);

  return { isInsituAvailable, disabledChart };
}
